import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetStocksQueryTypeResponse } from '~/types/stock.types';

const useGetStocksQueryType = () => {
  const endpoint = '/api-inventory/v1/third-parties/stocks/query-types';

  const getStocksQueryType = async () => {
    return axiosInstance
      .get<TypeGetStocksQueryTypeResponse>(endpoint)
      .then((data) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { getStocksQueryType };
};

export default useGetStocksQueryType;
